/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CloudWithArrow16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M8 6.2l3.3 3.4-.7.7-2.1-2.2v6.8h-1V8.1l-2.1 2.2-.8-.8L8 6.2zm-4.975-.102C3.345 3.795 4.9 1.8 8 2c2.3.1 3.5 1.437 3.902 3.005C14.24 5.472 15.9 7.399 15.9 9.8c0 2.8-1.9 5.1-4.4 5.1H10v-1.1h1.5c1.9 0 3.4-1.8 3.4-4.1 0-2.2-1.6-3.9-3.9-3.9C11 4 9.7 3 8 2.9c-2.4-.1-4.1 1.2-4 4-1.5.1-2.9 1.8-3 3.6 0 1.9 1.3 3.4 2.9 3.4H6v1H3.9c-2.2 0-3.8-2-3.8-4.4 0-1.97 1.247-3.794 2.925-4.402z"
        />
    </AccessibleSVG>
);

export default CloudWithArrow16;
